import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import StudentMenu from "../Students/StudentMenu";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Nav from "react-bootstrap/Nav";
import moment from "moment";
import axios from "axios";
import config from "../../Config";
import { scrollToTop } from "../Shared/ScrollOnTop";

function SchoolEventsManagement() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const fullName = localStorage.getItem("FullName") || localStorage.getItem("UserName") || "";

  const [tab, setTab] = useState("add");
  const [loadingPending, setLoadingPending] = useState(false);
  const [loadingApproved, setLoadingApproved] = useState(false);
  const [pending, setPending] = useState([]);
  const [approved, setApproved] = useState([]);
  const [selectedPending, setSelectedPending] = useState([]);

  const [eventTitle, setEventTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [eventDetails, setEventDetails] = useState("");
  const [titleImageBase64, setTitleImageBase64] = useState("");
  const [titleImagePreview, setTitleImagePreview] = useState("");
  const [showOnWebsite, setShowOnWebsite] = useState(false);
  const [showToStudents, setShowToStudents] = useState(true);
  const [showToStaff, setShowToStaff] = useState(true);

  const authPayload = {
    AccessKey,
    UserID: parseInt(UserID, 10) || 0,
    MemberType: MemberType || "Admin",
  };

  useEffect(() => {
    document.title = "School Events Management";
    loadPending();
    loadApproved();
  }, []);

  const loadPending = () => {
    setLoadingPending(true);
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/GetPendingSchoolEvents",
      headers: { "Content-Type": "application/json" },
      data: { ...authPayload, pageNo: 1, pageSize: 100 },
    })
      .then((res) => setPending(res.data.ListofRecords || []))
      .catch(() => toast.error("Failed to load pending events."))
      .finally(() => setLoadingPending(false));
  };

  const loadApproved = () => {
    setLoadingApproved(true);
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/GetApprovedSchoolEvents",
      headers: { "Content-Type": "application/json" },
      data: { ...authPayload, pageNo: 1, pageSize: 100 },
    })
      .then((res) => setApproved(res.data.ListofRecords || []))
      .catch(() => toast.error("Failed to load approved events."))
      .finally(() => setLoadingApproved(false));
  };

  const handleAdd = (e) => {
    e.preventDefault();
    if (!eventTitle.trim() || !startDate || !endDate) {
      toast.error("Title, start date and end date are required.");
      return;
    }
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/AddPendingSchoolEvent",
      headers: { "Content-Type": "application/json" },
      data: {
        ...authPayload,
        EventTitle: eventTitle.trim(),
        StartDate: startDate,
        EndDate: endDate,
        LocationAddress: locationAddress,
        EventDetails: eventDetails,
        TitleImage: titleImageBase64,
        ShowOnWebsite: showOnWebsite,
        ShowToStudents: showToStudents,
        ShowToStaff: showToStaff,
        Sender_Display_Name: fullName,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          toast.success(res.data.status_message || "Event submitted.");
          setEventTitle("");
          setStartDate("");
          setEndDate("");
          setLocationAddress("");
          setEventDetails("");
          setTitleImageBase64("");
          setTitleImagePreview("");
          loadPending();
        } else {
          toast.error(res.data.status_message || "Failed to save event.");
        }
      })
      .catch(() => toast.error("Network error."));
  };

  const handleTitleImageChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const dataUrl = e.target?.result || "";
      if (typeof dataUrl === "string") {
        setTitleImagePreview(dataUrl);
        const base64 = dataUrl.replace(/^data:image\/\w+;base64,/, "");
        setTitleImageBase64(base64);
      }
    };
    reader.readAsDataURL(file);
  };

  const deleteEvent = (id) => {
    if (!window.confirm("Delete this event?")) return;
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/DeleteSchoolEvent",
      headers: { "Content-Type": "application/json" },
      data: {
        ...authPayload,
        ID: id,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          toast.success("Event deleted.");
          loadPending();
          loadApproved();
        } else {
          toast.error(res.data.status_message || "Delete failed.");
        }
      })
      .catch(() => toast.error("Network error."));
  };

  const togglePending = (id) => {
    setSelectedPending((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const approveSelected = () => {
    if (selectedPending.length === 0) {
      toast.error("Select at least one event.");
      return;
    }
    axios({
      method: "post",
      url: config.base_url + "SchoolEvent/ApproveSchoolEvents",
      headers: { "Content-Type": "application/json" },
      data: {
        ...authPayload,
        SchoolEvent_ID_List: selectedPending,
        Approver_Display_Name: fullName,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          toast.success(res.data.status_message || "Approved.");
          setSelectedPending([]);
          loadPending();
          loadApproved();
        } else {
          toast.error(res.data.status_message || "Failed.");
        }
      })
      .catch(() => toast.error("Network error."));
  };

  return (
    <>
      <StudentMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard" onClick={scrollToTop}>Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item active">School Events</li>
                  </ol>
                </nav>
                <div className="page-title">School Events Management</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content mt-3">
          <div className="container">
            <Nav variant="tabs" activeKey={tab} onSelect={(k) => setTab(k || "add")} className="mb-3">
              <Nav.Item><Nav.Link eventKey="add">Add Event</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="pending">Pending Approval</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="approved">Approved Events</Nav.Link></Nav.Item>
            </Nav>

            {tab === "add" && (
              <div className="card"><div className="card-body">
                <form onSubmit={handleAdd}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Event title</label>
                      <input className="form-control" value={eventTitle} maxLength={300} onChange={(e) => setEventTitle(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Start date</label>
                      <input type="datetime-local" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">End date</label>
                      <input type="datetime-local" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">Location address</label>
                      <input className="form-control" value={locationAddress} maxLength={1000} onChange={(e) => setLocationAddress(e.target.value)} />
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">Event details</label>
                      <textarea className="form-control" rows={4} value={eventDetails} onChange={(e) => setEventDetails(e.target.value)} />
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">Title image</label>
                      <input type="file" accept="image/*" className="form-control" onChange={handleTitleImageChange} />
                      {titleImagePreview ? (
                        <div className="mt-2">
                          <img src={titleImagePreview} alt="preview" style={{ maxHeight: 120, borderRadius: 6 }} />
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-12 d-flex gap-4">
                      <div className="form-check"><input className="form-check-input" type="checkbox" checked={showOnWebsite} onChange={(e) => setShowOnWebsite(e.target.checked)} id="ew" /><label htmlFor="ew" className="form-check-label">Show on website</label></div>
                      <div className="form-check"><input className="form-check-input" type="checkbox" checked={showToStudents} onChange={(e) => setShowToStudents(e.target.checked)} id="es" /><label htmlFor="es" className="form-check-label">Show to students</label></div>
                      <div className="form-check"><input className="form-check-input" type="checkbox" checked={showToStaff} onChange={(e) => setShowToStaff(e.target.checked)} id="est" /><label htmlFor="est" className="form-check-label">Show to staff</label></div>
                    </div>
                    <div className="col-md-12 text-end">
                      <button type="submit" className="button button-primary">Save (Pending Approval)</button>
                    </div>
                  </div>
                </form>
              </div></div>
            )}

            {tab === "pending" && (
              <div className="card"><div className="card-body">
                <div className="mb-2 text-end">
                  <button className="button button-primary" onClick={approveSelected}>Approve selected</button>
                </div>
                {loadingPending ? <Spinner animation="border" /> : (
                  <table className="table table-theme table-sm">
                    <thead><tr><th></th><th>Title</th><th>Dates</th><th>Audience</th><th>Created by</th><th></th></tr></thead>
                    <tbody>
                      {pending.map((e) => (
                        <tr key={e.ID}>
                          <td><input type="checkbox" className="form-check-input" checked={selectedPending.includes(e.ID)} onChange={() => togglePending(e.ID)} /></td>
                          <td>{e.EventTitle}</td>
                          <td>{moment(e.StartDate).format("DD/MM/YYYY HH:mm")} - {moment(e.EndDate).format("DD/MM/YYYY HH:mm")}</td>
                          <td>{e.ShowOnWebsite ? "Website " : ""}{e.ShowToStudents ? "Students " : ""}{e.ShowToStaff ? "Staff" : ""}</td>
                          <td>{e.CreatedBy}</td>
                          <td className="text-end">
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => deleteEvent(e.ID)}>
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div></div>
            )}

            {tab === "approved" && (
              <div className="card"><div className="card-body">
                {loadingApproved ? <Spinner animation="border" /> : (
                  <table className="table table-theme table-sm">
                    <thead><tr><th>Title</th><th>Dates</th><th>Audience</th><th>Approved by</th><th></th></tr></thead>
                    <tbody>
                      {approved.map((e) => (
                        <tr key={e.ID}>
                          <td>
                            {e.TitleImage ? (
                              <img src={`${config.root}SchoolEvents/${e.TitleImage}`} alt="" style={{ width: 64, height: 40, objectFit: "cover", borderRadius: 4, marginRight: 8 }} />
                            ) : null}
                            {e.EventTitle}
                          </td>
                          <td>{moment(e.StartDate).format("DD/MM/YYYY HH:mm")} - {moment(e.EndDate).format("DD/MM/YYYY HH:mm")}</td>
                          <td>{e.ShowOnWebsite ? "Website " : ""}{e.ShowToStudents ? "Students " : ""}{e.ShowToStaff ? "Staff" : ""}</td>
                          <td>{e.ApprovedBy}</td>
                          <td className="text-end">
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => deleteEvent(e.ID)}>
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SchoolEventsManagement;
